import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Star, MapPin, Bookmark } from "lucide-react";
import { Badge } from "../components/ui/badge";

const Bookmarks = () => {
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/bookmarks").then(r => {
      setBookmarks(r.data);
      setLoading(false);
    });
  };

  useEffect(() => { load(); }, []);

  const removeBookmark = async (rid) => {
    await api.post(`/bookmarks/toggle/${rid}`);
    load();
  };

  return (
    <div data-testid="bookmarks-page">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">My Saves</p>
        <h1 className="font-heading text-3xl font-black mt-2">Restoran Favorit</h1>
        <p className="text-muted-foreground mt-2">{bookmarks.length} restoran tersimpan</p>
      </div>

      {loading ? (
        <div className="text-center py-20 text-muted-foreground">Memuat...</div>
      ) : bookmarks.length === 0 ? (
        <div className="warm-card p-12 text-center">
          <Bookmark className="w-12 h-12 mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">Belum ada restoran tersimpan. Klik ikon bookmark di restoran favorit kamu!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="bookmarks-grid">
          {bookmarks.map(b => b.restaurant && (
            <div key={b.id} className="warm-card group relative" data-testid={`bookmark-${b.restaurant.slug}`}>
              <Link to={`/restaurants/${b.restaurant.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-muted">
                  <img src={b.restaurant.cover_image} alt={b.restaurant.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <Badge variant="secondary" className="text-[10px] uppercase tracking-wider">{b.restaurant.category?.replace("-", " ")}</Badge>
                  <h3 className="font-heading font-bold text-base leading-tight mt-2">{b.restaurant.name}</h3>
                  <div className="flex items-center justify-between mt-3 text-sm">
                    <span className="flex items-center gap-1">
                      <Star className="w-4 h-4 fill-primary text-primary" />
                      <span className="font-semibold">{b.restaurant.avg_rating?.toFixed(1) || "—"}</span>
                    </span>
                    <span className="flex items-center gap-1 text-xs text-muted-foreground">
                      <MapPin className="w-3 h-3" /> Serpong
                    </span>
                  </div>
                </div>
              </Link>
              <button
                onClick={() => removeBookmark(b.restaurant.id)}
                className="absolute top-3 right-3 w-9 h-9 rounded-full bg-card/90 backdrop-blur flex items-center justify-center hover:bg-primary hover:text-primary-foreground"
                data-testid={`remove-bookmark-${b.restaurant.slug}`}
              >
                <Bookmark className="w-4 h-4 fill-current" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Bookmarks;
